// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AppEngineSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AppEngineSignetIcon" ref={forwardedRef} {...props}>
      <path d="M15.468 4H8.08C6.957 4 6.047 4.954 6.047 6.13v.926c0 .32.248.58.553.58h3.465c.3 0 .563.232.59.545.03.356-.237.655-.571.655H5.479a.587.587 0 0 0-.558.599.585.585 0 0 0 .543.6H7.78a.6.6 0 0 1 .592.596.59.59 0 0 1-.483.596 1 1 0 0 1-.09.007H5.127a1 1 0 0 1-.09-.007H3.553a.587.587 0 0 0-.572.6.6.6 0 0 0 .423.58h7.286c.3 0 .563.232.59.545.029.356-.238.654-.571.654H6.048l-.002.002v.263C6.046 15.047 6.956 16 8.08 16h7.389c1.122 0 2.032-.953 2.032-2.13V6.13C17.5 4.952 16.59 4 15.468 4m-3.524 7.234h-1.856a1 1 0 0 1-.09-.007.59.59 0 0 1-.483-.596.6.6 0 0 1 .592-.597h1.819c.3 0 .563.234.589.547.03.356-.238.653-.57.653" />
      <path d="M3.242 10.035H2.048c-.302 0-.548-.269-.548-.6s.246-.6.548-.6h1.194c.303 0 .548.269.548.6s-.245.6-.548.6" />
      <path d="M4.448 7.636H3.254c-.303 0-.548-.269-.548-.6s.245-.6.548-.6h1.194c.303 0 .548.269.548.6s-.245.6-.548.6" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AppEngineSignetIcon = /* @__PURE__ */ Object.assign(
  AppEngineSignetIconComponent,
  { displayName: 'AppEngineSignetIcon' },
);
